import { useStoreActions, useStoreState } from 'easy-peasy';
import { useEffect } from 'react';
import { api } from '../services/api';
import { useQuery, useQueryClient } from '@tanstack/react-query'


export const useVideos = () => {
    const videos = useStoreState(state => state.video.videos);
    const isLoading = useStoreState(state => state.video.isLoading);
    const fetchVideos = useStoreActions(actions => actions.video.fetchVideos);

    useEffect(() => {
        fetchVideos();
    }, [fetchVideos]);

    return {
        videos,
        isLoading
    };
}

const useGetVideoData = () => {
  return useQuery({
    queryKey: ['videos'],
    queryFn: async () => {
      const response = await api.fetchVideos()
      return JSON.parse(response.videos)
    },
    enabled: true,
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}


